import i18n from '../../i18n';

/**
 * Human-readable message for a failed request.
 *
 * Backend errors come as ErrorDto `{ error, status }` (GlobalExceptionHandler): 400/422 carry a
 * business message worth showing ("Insufficient coin balance: has 1200, needs 65000"), while 5xx
 * texts are internal and are replaced by `fallback`. Axios' own "Request failed with status code N"
 * is never shown to the user. `message` is `error` translated to the request language (v1.49.0).
 */
export function getApiErrorMessage(err, fallback) {
  fallback = fallback || i18n.t('error.something_went_wrong', 'Something went wrong. Please try again later.');
  if (!err) return fallback;
  const res = err.response;
  if (!res) {
    if (err.code === 'ERR_NETWORK' || /network/i.test(err.message || '')) {
      return i18n.t('error.no_connection', 'No connection. Check your internet and try again.');
    }
    return err.message && !/status code/i.test(err.message) ? err.message : fallback;
  }
  if (res.status >= 500) return fallback;
  const data = res.data || {};
  if (data.error === 'LEGAL_ACCEPTANCE_REQUIRED') return i18n.t('error.legal_required', 'Please accept the Terms to continue.');
  const text = data.message || data.error || data.description;
  return typeof text === 'string' && text.trim() ? text : fallback;
}

/** True when the wallet / user aborted the action (nothing to show, just close). */
export function isUserCancelledError(err) {
  const msg = String(err?.message || '');
  const name = String(err?.name || '');
  return /reject|cancel|declin|Transaction was not sent|UserRejects/i.test(msg)
    || /UserRejects/i.test(name);
}

/** TON Connect SDK/UI errors carry [TON_CONNECT_*] tags or TonConnect* class names. */
export function isTonConnectError(err) {
  return /TON_CONNECT|TonConnect/i.test(String(err?.message || '') + String(err?.name || ''));
}
